<template>

    <div>
        <div v-if="custom_list.length>0">
            <common-list  :pageurl="this.$api_url" :is_action=1 :checkbox="checkbox"  :is_pf="is_n_pf" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>
        </div>
        <div v-else>
            <div v-if="show_loader" class="list-no-data">
                <span class="d-block text-center">Looking for relevant data..</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
            </div>
            <div v-else class="list-no-data">
                Looks like there is no employee to show.
            </div>
        </div>
       

        <pf-profile-overview :pageurl="pageurl" :title="title" :employee_id="curr_emp_id" :show="show" :is_end="is_end"  :curr_pf_id="curr_pf_id" :key="overview_key" v-on:childToParent="overviewReturn"></pf-profile-overview>
 
        <pf-settlement-form :employee_id ="curr_emp_id" :employee_name="curr_emp_name" :pageurl="pageurl" :settlement_id="settlement_id" :key="settle_form_key" v-on:childToParent="overviewReturn" ></pf-settlement-form>
    </div>

</template>
<script>
    export default{
        
        mounted() {
            
            this.showoverlay = false;
        },
        props: ['flg','pageurl','is_action'],
        components: {
     
        },
        data(){            

            return {
                checkbox:0,
                overview_key:0,
                curr_pf_id:0,
                is_end:0,
                title:'',
                show:0,
                min_date:'',
                showoverlay : true,
                errormsg:[],
                curr_approve_date:'',
                curr_emp_name:'',
                curr_emp_id:0,
                /*new vars */
                pf_from_disable:false,
                people: 0,
                blankmsg: '',
                is_n_pf:1,
                /**Child Component property data */
                list_key:0, /* Component Key */
                custom_list:[],  /* Data List */
                default_column:['name','email','jobposition'], /* Default Column List */
                appended_column:[
                    
                    // { value: "pf_total", text: "Total Balance",type: "number"}, // Rejwan: 23-04-2025
                    { value: "pf_total", text: "Total Balance",type: "amount"}, // Rejwan: 23-04-2025
                    { value: "pf_start", text: "PF Start Date",type: "date"},
                    { value: "pf_end", text: "PF End Date",type: "date"},
                ],                  
                
                /* Appended Column List  and there title and type */
                primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                tmp_custom_list:[],

                custom_array:[],

                /***Child Component property data */

                settle_form_key:0,
                settlement_id:0,
            }
        },
        methods:{

            
            toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return 0;
            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // }, 
            listReturn:function(data)
            {
            
                if(data.employee_id && data.action_id==1)
                {
                    let tmp_list  = this.tmp_custom_list;
                    var item  = tmp_list.find(item => item.employee_id === data.employee_id); 
                    this.curr_emp_name = item.name;
                    this.curr_emp_id = item.employee_id;
                    this.curr_approve_date=item.pf_end;
                    this.settle_form_key += 1;
                }

                if(data.employee_id && data.action_id==3)
                {
                    let tmp_list  = this.tmp_custom_list;
                    var item  = tmp_list.find(item => item.employee_id === data.employee_id); 
                    
                    this.curr_emp_id =item.employee_id;
                    this.curr_emp_name=item.name;
                     this.show +=  1; 
                    this.is_end =  1; 
                    this.overview_key +=  1; 
                    this.title =  'PF Employee Provident Fund End'; 
                
                 
                }
 
                if(data.employee_id && data.action_id==4)
                {
                    let tmp_list  = this.tmp_custom_list;
                    var item  = tmp_list.find(item => item.employee_id === data.employee_id); 
                    
                    this.curr_emp_id =item.employee_id;
                    this.curr_emp_name=item.name;
                     this.show +=  1; 
                    this.is_end =  0; 
                    this.overview_key +=  1; 
                    this.title =  'PF Employee Profile Overview'; 
                    
                 
                }

                console.log(this.curr_emp_id);
                console.log(this.curr_approve_date);
                console.log(this.curr_emp_name);
    
            },
            getLeaverEmployeeListData: function()
            {
                let currentObj = this;
                if(!this.checkNet()) return false;

                this.show_loader = true;
                axios.get(this.$api_url+'/pf/leaver/list' , {

                }).then(function(response){

                    
                    
                    let leaver_custom = [];
                    /* Assingning the Options */ 

                    this.company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));

                    /* Assingning the list */ 
                    this.tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                    
                    if(this.tmp_custom_list.length > 0 )
                    {

                         
                        this.tmp_custom_list.forEach(element => {
                                if(element.employee_id > 0)
                                {
                                    element.pf_total = this.formatMoney(element.pf_total);
                                    let dop = []; 
                                    /*  If DropDown type one is First Choice */
                                    
                                    if(element.pf_end != '0000-00-00' && element.pf_end != '')
                                    {
                                        
                                        dop = dop.concat([{ label: 'Process Settlement' , value: 1 }]);
                                        dop = dop.concat([{ label: 'Quick View' , value: 4 }]);
                                    }
                                    else
                                    {
                                        dop = dop.concat([{ label: 'End PF' , value: 3 }]);
                                        dop = dop.concat([{ label: 'Quick View' , value: 4 }]);
                                    }
                                        
                                        //
                                    
                                    /* Action for all column **/

                                    element.actions = dop; 
                                    leaver_custom.push(element);
                                    if(element.last_payslip_date != null)
                                    {
                                        // if(element.leaving_date != '0000-00-00' && element.leaving_date != '')
                                        // {

                                        //     const last_payslip_date = element.last_payslip_date.split('-');
                                        //     var last_payslip_date_format = new Date(last_payslip_date[0],last_payslip_date[1]-1,1);
                                        //     const leaving_date = element.leaving_date.split('-');
                                        //     var leaving_date_format = new Date(leaving_date[0],leaving_date[1]-1,1);

                                        //     if(last_payslip_date_format.getTime() === leaving_date_format.getTime())
                                        //     {
                                                //leaver_custom.push(element);
                                                
                                            // }   
                                            
                                        //}

                                    }
                                    
                                }
                            }); 

                            // console.log(leaver_custom.length);
                        
                    }
                    else
                    {
                        this.blankmsg = "No employee found as leaver";
                    }
                    
                    this.custom_list = leaver_custom;
                    this.list_key = this.list_key + 1;
                    this.show_loader = false;
                }.bind(this)).catch(function (error){

                    console.log(error);
                    currentObj.serverError(error);
                    
                    });

            },
            overviewReturn:function()
            {
                this.$validator.reset();
                this.getLeaverEmployeeListData();
            },
       
        },
        created: function(){
            if(!this.checkNet()) return false;
            this.$validator.reset();
            this.getLeaverEmployeeListData();
            
        },
        computed: 
        {
            
        }
    }
</script>